import React, { useEffect, useState } from "react";
import styles from "./DetailRaffle.module.sass";
import { useUser } from "../../../../../context";
import cn from "classnames";
import raffle from "../../../../../i11/Raffle";
import Card from "../../../../../components/Card";
import Loader from "../../../../../components/Loader";
import TextInput from "../../../../../components/TextInput";
import { GetRaffleDetail } from "../../../../../Services/lib/nfttemplates";
import { UseApi } from "../../../../../hooks/use-api";
const dFormat = (date) => new Date(date).toLocaleString();

const DetailRaffle = ({ data }) => {
	const { locale } = useUser();

	const [raffleDetail, setDetail] = useState();

	const [{ isLoading: editLoading }, getRaffleDetail] = UseApi({
		service: GetRaffleDetail,
	});

	const getDetail_ = async () => {
		const res = await getRaffleDetail(data._id);
		if (res) {
			setDetail(res);
		}
	};

	useEffect(() => {
		getDetail_();
	}, []);

	return (
		<Card
			className={styles.card}
			title={raffle[locale].raffle_name}
			classTitle="title-green"
		>
			<div className={styles.overview}>
				<div className={styles.line}>
					<div className={cn("h4", styles.title)}>{data.name}</div>
					<p className={styles.status}>{data.status}</p>
					{editLoading && <Loader className={styles.lm30} />}
				</div>
				<div className={styles.info}>{data.description}</div>
				<div className={styles.row}>
					<div className={styles.col}>
						<div className={styles.top}>
							<div className={styles.img}>
								<img src={data?.image || "_"} alt="__alt" />
							</div>
						</div>
					</div>

					<div className={styles.col}>
						<div className={cn("title-blue", styles.subtitle)}>
							{raffle[locale].date}
						</div>
						<p>{raffle[locale].start_date}</p>
						<TextInput
							className={styles.textInput}
							disabled={true}
							type="text"
							value={dFormat(data.startDate)}
						/>
						<br />
						<p>{raffle[locale].end_date}</p>
						<TextInput
							disabled={true}
							type="text"
							value={dFormat(data.endDate)}
						/>
						<br />
						<p>{raffle[locale].created_at}</p>
						<TextInput
							disabled={true}
							type="text"
							value={dFormat(data.createdAt)}
						/>
					</div>
					{raffleDetail && (
						<div className={styles.col}>
							<div className={cn("title-red", styles.subtitle)}>
								{raffle[locale].prizes}
							</div>
							{raffleDetail?.prizes.map((e) => (
								<Row prize={e} key={e._id} />
							))}
						</div>
					)}
				</div>

				<div>
					{raffleDetail && (
						<div className={styles.col}>
							<div className={cn("title-green", styles.subtitle)}>
								{raffle[locale].criterians}
							</div>
							{raffleDetail?.criterians.map((e, index) => (
								<RowCr
									criterian={e}
									key={e._id}
									i={index + 1}
								/>
							))}
						</div>
					)}
				</div>
			</div>
		</Card>
	);
};

const Row = ({ prize }) => {
	return (
		<div className={styles.prizeRow}>
			<div className={styles.smallImg}>
				<img
					src={
						prize?.data?.image ||
						"/images/content/product-pic-6.jpg"
					}
					alt={"_image"}
				/>
			</div>
			<div>
				{prize.data.name}
				<p className={styles.desc}>{prize.data.description}</p>
			</div>
		</div>
	);
};

const RowCr = ({ criterian, i }) => {
	const { locale } = useUser();

	return (
		<div className={styles.criterian}>
			{raffle[locale].criterian + " " + i}
			<div className={styles.criterianRow}>
				{criterian?.list.map((e) => {
					return (
						<div className={styles.criterianRow}>
							<div className={styles.smallImg}>
								<img
									src={
										e?.image ||
										"/images/content/product-pic-6.jpg"
									}
									alt={"_image"}
								/>
							</div>

							<div>
								{e.name}
								<p className={styles.desc}>{e.description}</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default DetailRaffle;
